import axiosClient from "../axiosClient";

export const logInAdmin = async (data) => {
    return await axiosClient.post('/admin_login', data);
};

export const adminforgot_password = async (data) => {
    return await axiosClient.post('/admin_forgot_password', data);
};

export const tokenVerified = async (data) => {
    return await axiosClient.get(`/admin_verified_token/${data?.token}`);
};

export const adminResetPassword = async (data) => {
    return await axiosClient.put('/admin_change_password', data);
};

export const addAdmin = async (data) => {
    return await axiosClient.post('/add_admin', data);
};

export const getAdminDetail = async (id) => {
    return await axiosClient.get(`/get_admin_details/${id}`);
};

export const getS3Url = async () => {
    return await axiosClient.get('/generate_s3_signedurl');
};

export const getActionLogs = async () => {
    return await axiosClient.get('/get_all_log');
};

export const getActionActivity = async () => {
    return await axiosClient.get('/get_all_admin_login_log');
};

export const updateProfile = async (data) => {
    return await axiosClient.put('/update_admin_profile', data);
};

export const updatePassword = async (data) => {
    return await axiosClient.put('/change_admin_password', data);
};

export const LoginUser = async (data) => {
    return await axiosClient.post(`/ghost_login`, data);
};

/** pre-college */

export const LoginUserPreCollege = async (data) => {
    return await axiosClient.post(`/preclg_ghost_login`, data);
};

/** Career-Launch */

export const LoginUserCareer = async (data) => {
    return await axiosClient.post(`/cl_ghost_login`, data);
};

/** certificates */

export const LoginUsercertificates = async (data) => {
    return await axiosClient.post(`/cert_ghost_login`, data);
};

export const LoginUserDl = async (data) => {
    return await axiosClient.post(`/dl_ghost_login`, data);
};